import React from 'react';
import {Link} from 'react-router-dom';
import {Fairs} from 'api';
import {connect} from 'react-redux';
import {UploadImage} from 'components/UI/Image';
import style from './_BusinessBox.scss';
import { ShowIf } from 'components/utils';
import {toastr} from 'react-redux-toastr';

class BusinessItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  addBusiness() {
    if (confirm("Bạn có muốn thêm doanh nghiệp này vào hội chợ không?")) {
      Fairs.actions.addBusiness.request({id: this.props.fairID, businessIds: this.props.data.id}).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Thêm doanh nghiệp thành công");
        this.props.dispatch({
          type: 'ADD_BUSINESS_FAIR',
          id: this.props.data.id
        });
      });
    }
  }

  render() {
    let Img = null;
    let Data = this.props.data || {};
    if (Data.logo) {
      Img = <UploadImage width={128} height={128} type='BUSINESS' image={Data.logo} transform='crop'/>
    } else {
      Img = <img className="media-object" src={require('assets/images/placeholder-128.jpg')} alt="..." width="128" height="128" alt="logo doanh nghiệp"/>;
    }

    return (
      <div className="business">
        <div className='image-content'>
          {Img}
        </div>
        <div className='info-content'>
          <p className='name'>{Data.name}</p>
          <span className='desc pr10'>
            {Data.address}<br/>
            Số điện thoại: {Data.phone}
          </span>
          <span className='desc'>
            Email: <a href={`mailto:(${Data.email})`}>{Data.email}</a><br/>
          </span>
          <ShowIf condition={Data.exist === true && this.props.view !== true}>
            <div className='action-panel'>
              <button className='btn btn-success'>Doanh nghiệp đã có trong hội chợ</button>
            </div>
          </ShowIf>
          <ShowIf condition={Data.awaiting === true && this.props.view !== true}>
            <div className='action-panel'>
              <button className='btn btn-primary'>Duyệt doanh nghiệp này</button>
            </div>
          </ShowIf>
          <ShowIf condition={Data.exist !== true && Data.awaiting !== true && this.props.view !== true}>
            <div className='action-panel'>
              <button className='btn btn-primary' onClick={this.addBusiness.bind(this)}>Thêm vào hội chợ</button>
            </div>
          </ShowIf>
        </div>
      </div>
    );
  }
}

export default connect()(BusinessItem);



// WEBPACK FOOTER //
// ./components/fair/fair-business/BusinessItem.jsx